<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Dicas Técnicas</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="tips">Dicas Técnicas</label>
                                    <select name="tips[]" id="tips" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(tip, index) in tips">
                                            {{ tip.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setTips">Ordenar Dicas Técnicas <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(tip,index) in selected' :key="tip.id" class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left" ></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="pull-left stages" :id="'stage' + tip.id">{{ index + 1 }}. {{ tip.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(tip, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar</button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default{
        data: function(){
            return {
                tips: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getTipsArray: function(data){
                let array = [];
                $.each(data, function(index, value){
                    if(value.sort_by){
                        array.push(index);
                    }
                });
                return array;
            },
            getTips: function(){
                let self = this;
                let api  = self.$store.state.api + 'tip?paginated=false';
                let tips = $('#tips');

                self.$http.get(api)
                    .then((response) => {
                        self.tips = response.data.data;
                        self.ordered  = self.getTipsArray(self.tips);
                    })
                    .then(() => {
                        tips.bootstrapDualListbox();
                        tips.ready(function () {
                            tips.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Tips', 'error');
                    });
            },
            setTips: function(){
                const self   = this;
                let tips = self.selected;

                $('#tips').find(':selected').each(function(){
                    tips.push(self.tips[$(this).val()]);
                });

                self.selected = tips;
                self.order = true;
            },
            save: function(){
                const self = this;

                postReorder(self, self.selected, "sort/tip", self.getTipsArray);
            },
            remove: function(tip, index){
                const self = this;
                const api  = self.$store.state.api + 'tip/' + tip.id;

                let array  = [];
                $.each(self.selected, function(key, value){
                    if(index !== key){
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function(){
                window.location.reload();
            }
        },
        mounted: function(){
            this.getTips();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TipOrder/Index.vue